import { useEffect, useState } from 'react';
import * as Yup from 'yup'
import { selector } from '../../../api';
import { Personal, Residential, Registration, Other, Finish } from "./modals"
import { kayaCRUD } from '../../../actions/kaya';
import { toast } from 'react-toastify';
import { Loading } from '../../constant';
import moment from 'moment';


const personalSchema = Yup.object().shape({
  StartDate: Yup.date().default(() => new Date()),
  full_name: Yup.string().required('Full name is required'),
  dob: Yup.date().max(Yup.ref('StartDate'),"Date of birth can't be after today").required('Date of birth is required'),
  pob: Yup.string().required('Place of birth is required'),
  emaila_ddress: Yup.string().email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols'),
  dictionary_gender: Yup.string().required('Gender is required'),
});

const residentialSchema = Yup.object().shape({
  dictionary_relation_to_head: Yup.string().required('Relationship is required'),
});

const regSchema = Yup.object().shape({
  StartDate: Yup.date().default(() => new Date()),
  reg_date: Yup.date().max(Yup.ref('StartDate'),"Registration date can't be after today").required('Registration date is required'),
  reg_no: Yup.string().required('Registration number is required'),
  kaya_id: Yup.string().required('House hold is required'),
});

const otherSchema = Yup.object().shape({
  dictionary_marital_status: Yup.string().required('This field is required'),
  dictionary_economic_activity: Yup.string().required('This field is required'),
  dictionary_literacy_level: Yup.string().required('This field is required'),
  dictionary_education_level: Yup.string().required('This field is required'),
  dictionary_health_status: Yup.string().required('This field is required'),
  dictionary_disability_status: Yup.string().required('This field is required'),
  dictionary_nutrition_status: Yup.string().required('This field is required'),
  dictionary_vaccination_info: Yup.string().required('This field is required'),
  dictionary_residential_status: Yup.string().required('This field is required'),
  dictionary_mosquito_net_status: Yup.string().required('This field is required'),
});

export const EditKayaMember = (props) => {

  const user = selector.User()

  const {index, setIndex, dataId} = props

  const [memberLoading, setMemberLoading] = useState(false)

  const [data, setData] = useState({
    code: '',
    full_name: '',
    dob: '',
    phone_number: '',
    dictionary_gender: '',
    emaila_ddress: '',
    reg_no: 1111,
    reg_date: '',
    dictionary_relation_to_head: '',
    pob: '',
    birth_certificate_no: '',
    zan_id_no: '',
    nida_no: '',
    pasport_no: '',
    dictionary_marital_status: '',
    dictionary_economic_activity: '',
    dictionary_literacy_level: '',
    dictionary_education_level: '',
    dictionary_health_status: '',
    dictionary_disability_status: '',
    dictionary_nutrition_status: '',
    dictionary_vaccination_info: '',
    dictionary_residential_status: '',
    emigration_date: null,
    incoming_date: null,
    dictionary_mosquito_net_status: '',
    detail_info: '',
    kaya_id: 1,
    edited_by: user.id
  })

  useEffect(() => {
    if (!dataId) return;

    setMemberLoading(true)
    setTimeout(() => {
      kayaCRUD.loadMemberUpdate(dataId).then((resp) => {
        setData({
          code: resp.data.code ? resp.data.code : '',
          full_name: resp.data.full_name ? resp.data.full_name : '',
          dob: resp.data.dob ? resp.data.dob : '',
          phone_number: resp.data.phone_number ? resp.data.phone_number : '',
          dictionary_gender: resp.data.dictionary_gender ? resp.data.dictionary_gender : '',
          emaila_ddress: resp.data.emaila_ddress ? resp.data.emaila_ddress : '',
          reg_no: resp.data.reg_no ? resp.data.reg_no : '',
          reg_date: resp.data.reg_date ? resp.data.reg_date : '',
          dictionary_relation_to_head: resp.data.dictionary_relation_to_head ? resp.data.dictionary_relation_to_head : '',
          pob: resp.data.pob ? resp.data.pob : '',
          birth_certificate_no: resp.data.birth_certificate_no ? resp.data.birth_certificate_no : '',
          zan_id_no: resp.data.zan_id_no ? resp.data.zan_id_no : '',
          nida_no: resp.data.nida_no ? resp.data.nida_no : '',
          pasport_no: resp.data.pasport_no ? resp.data.pasport_no : '',
          dictionary_marital_status: resp.data.dictionary_marital_status ? resp.data.dictionary_marital_status : '',
          dictionary_economic_activity: resp.data.dictionary_economic_activity ? resp.data.dictionary_economic_activity : '',
          dictionary_literacy_level: resp.data.dictionary_literacy_level ? resp.data.dictionary_literacy_level : '',
          dictionary_education_level: resp.data.dictionary_education_level ? resp.data.dictionary_education_level : '',
          dictionary_health_status: resp.data.dictionary_health_status ? resp.data.dictionary_health_status : '',
          dictionary_disability_status: resp.data.dictionary_disability_status ? resp.data.dictionary_disability_status : '',
          dictionary_nutrition_status: resp.data.dictionary_nutrition_status ? resp.data.dictionary_nutrition_status : '',
          dictionary_vaccination_info: resp.data.dictionary_vaccination_info ? resp.data.dictionary_vaccination_info : '',
          dictionary_residential_status: resp.data.dictionary_residential_status ? resp.data.dictionary_residential_status : '',
          emigration_date: resp.data.emigration_date ? resp.data.emigration_date : null,
          incoming_date: resp.data.incoming_date ? resp.data.incoming_date : null,
          dictionary_mosquito_net_status: resp.data.dictionary_mosquito_net_status ? resp.data.dictionary_mosquito_net_status : '',
          detail_info: resp.data.detail_info ? resp.data.detail_info : '',
          kaya_id: 1,
          edited_by: user.id
        })
      }).finally(() => {
        setMemberLoading(false)
      })
    },1000)
  },[dataId])
    

  const [dataSend] = useState(data)

  const [activeStep, setActiveStep] = useState(0);
  const [step1, setStep1] = useState(false)
  const [step2, setStep2] = useState(false)
  const [step3, setStep3] = useState(false)
  const [step4, setStep4] = useState(false)
  const [loading, setLoading] = useState(false)
  const [age, setAge] = useState(null)

  useEffect(() => {
    setAge(moment().diff(data.dob, 'years'));
    if(moment().diff(data.dob, 'years')>=6){
      data.dictionary_nutrition_status = 98
    }
    if(moment().diff(data.dob, 'years')<=15 || moment().diff(data.dob, 'years')>=49 || data.dictionary_gender!==2){
      data.dictionary_vaccination_info = 99
    }
  },[data.dob, data.dictionary_gender])


  const handleNext = (newData, isLast = false) => {
    setData(prev => ({...prev, ...newData}))

    const head = newData.dictionary_relation_to_head

    const is_head = (head == 4 ? true : false)

    const {code, full_name, dob, phone_number, dictionary_gender, email, reg_no, reg_date, dictionary_relation_to_head,
           pob, birth_certificate_no, zan_id_no, nida_no, pasport_no, dictionary_marital_status, dictionary_economic_activity, dictionary_literacy_level,
           dictionary_education_level, dictionary_health_status, dictionary_disability_status, dictionary_nutrition_status, dictionary_vaccination_info, dictionary_residential_status,
           dictionary_mosquito_net_status, emigration_date, incoming_date, detail_info, edited_by} = newData

    const member = {code,full_name,dob,phone_number,dictionary_gender,email,reg_no,reg_date, is_head, dictionary_relation_to_head,pob,birth_certificate_no,
                    zan_id_no,nida_no,pasport_no,dictionary_marital_status,dictionary_economic_activity,dictionary_literacy_level,dictionary_education_level,
                    dictionary_health_status, dictionary_disability_status, dictionary_nutrition_status, dictionary_vaccination_info, dictionary_residential_status, dictionary_mosquito_net_status,
                    emigration_date, incoming_date, detail_info, edited_by}



    if(isLast){
      setLoading(true)
      setTimeout(() => {
        kayaCRUD.updateMember(dataId, member).then(() => {
          setIndex(index+1)
          toast.success('Member has been updated.', { autoClose: 7000 })
        }).catch((error) => {
          toast.error(error, { autoClose: 7000 })
        }).finally(() => {
          setLoading(false)
          setData(dataSend)
          setStep1(false)
          setStep2(false)
          setStep3(false)
          setStep4(false)
          setActiveStep(0)
        })
      },5000)
    } 

    setActiveStep(prev => prev + 1)
  }

  const handlePrev = (newData) => {
    setData(prev => ({...prev, ...newData}))
    setActiveStep(prev => prev - 1)
  }

  const steps = [
      <Personal next={handleNext} data={data} step1={step1} setStep1={setStep1} schema={personalSchema}/>,
      <Residential next={handleNext} back={handlePrev} data={data} step2={step2} setStep2={setStep2} step1={step1} setStep1={setStep1} schema={residentialSchema}/>,
      <Registration next={handleNext} back={handlePrev} data={data} step3={step3} setStep3={setStep3} step2={step2} setStep2={setStep2} schema={regSchema}/>,
      <Other next={handleNext} back={handlePrev} data={data} step3={step3} setStep3={setStep3} step4={step4} setStep4={setStep4} schema={otherSchema} age={age} loading={loading}/>,
      <Finish/>
  ]


  return (
    <>
      <div className="modal fade editmodal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-soft-primary">
              <h5 className="modal-title d-flex align-items-center" id="myLargeModalLabel">
                <i className="ri-user-settings-line fs-18 me-2 text-primary"></i>
                Edit Household Member
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {memberLoading ?
                <Loading/>
               :
                <div className="form-steps">
                <div className="step-arrow-nav mb-4">
                  <ul className="nav nav-pills custom-nav nav-justified" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className={!step1 ? "nav-link active" : "nav-link"} id="step-personal-tab" type="button" role="tab" aria-controls="step-personal-info" aria-selected="true">Personal</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={step2 ? 'nav-link' : !step1 ? 'nav-link' : 'nav-link active'} id="step-identity-tab" type="button" role="tab" aria-controls="step-identity-info" aria-selected="false">Residential</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={step3 ? 'nav-link' : !step2 ? 'nav-link' : 'nav-link active'} id="step-register-tab" type="button" role="tab" aria-controls="step-register-info" aria-selected="false">Registration</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={step4 ? "nav-link" : !step3 ? "nav-link" : "nav-link active"} id="step-relation-tab" type="button" role="tab" aria-controls="step-relation-info" aria-selected="false">Other Info</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={step4 ? "nav-link active" : "nav-link"} id="step-relation-tab" type="button" role="tab" aria-controls="step-relation-info" aria-selected="false">Finish</button>
                    </li>
                  </ul>
                </div>

                <div className="tab-content">
                {steps[activeStep]}
                </div>
              </div>
              }
            </div>
            <div className="modal-footer">
              {/* <a href="javascript:void(0);" className="btn btn-outline-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
              <button type="button" className="btn btn-success ">
                <i className="las la-save la-lg"></i> &nbsp; Save changes
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )

}